<span #svg [hidden]="bandeira.imagemUrl"></span>

<span *ngIf="bandeira.imagemUrl">
  <img  [src]="bandeira.imagemUrl" style="max-width: 30px; max-height: 20px" alt="{{textoString}}" >
</span>


<span class="ml-2 k-display-inline-block"><b>{{textoString}}</b></span>
